import { fetch_users_by_role } from '@/services/workflow_service';
import { normalize_text, to_array, to_number } from './view_case_details_core_helpers';
import {
  normalize_reassign_user,
  response_data_array,
  response_data_value,
} from './view_case_details_record_helpers';

export function reviewer_payloads(response) {
  const data = response_data_value(response);
  return Array.isArray(data) ? data : (data ? [data] : []);
}

export function reviewer_users_from_payloads(payloads = []) {
  return payloads.flatMap((payload) =>
    to_array(payload?.users).map((assignment) => ({
      ...assignment,
      reviewer_source: 'user',
    }))
  );
}

export function reviewer_roles_from_payloads(payloads = []) {
  return payloads.flatMap((payload) => to_array(payload?.roles));
}

function reviewer_role_id(role = {}) {
  return to_number(role?.role_id || role?.id);
}

function reviewer_role_name(roles = [], role_id = null) {
  const role = roles.find((item) => reviewer_role_id(item) === role_id);
  return normalize_text(role?.role_name || 'Reviewer');
}

function unique_role_ids(roles = []) {
  return [...new Set(roles.map(reviewer_role_id).filter(Boolean))];
}

async function users_for_role(role_id, roles = []) {
  const response = await fetch_users_by_role({ role_id });
  return response_data_array(response).map((user) => ({
    user,
    role_id,
    role_name: normalize_text(user?.role_name || reviewer_role_name(roles, role_id)),
    reviewer_source: 'role',
  }));
}

export async function users_for_reviewer_roles(roles = []) {
  const role_user_groups = await Promise.all(
    unique_role_ids(roles).map((role_id) => users_for_role(role_id, roles))
  );

  return role_user_groups.flat();
}

export function unique_reassign_users(users = []) {
  const seen = new Set();
  return users.filter((user) => {
    const normalized = normalize_reassign_user(user);
    const keep_user = Boolean(normalized.user_id && !seen.has(normalized.user_id));
    if (keep_user) seen.add(normalized.user_id);
    return keep_user;
  });
}

export function today_iso_date() {
  return new Date().toISOString().slice(0, 10);
}
